import React from 'react';
import styles from './Entry.module.scss';

interface Props {
  children: React.ReactNode;
  icon: React.ReactNode;
  keyword: string;
}

const Entry: React.FC<Props> = (props) => {
  return (
    <div className={styles.entry}>
      {props.icon}
      <div className={styles.keyword}>{props.keyword}</div>
      <div>{props.children}</div>
    </div>
  );
};

Entry.displayName = 'Entry';

export default Entry;
